import React from "react";

class ConnectToInternet extends React.Component {
    render() {
        return (
          <section className="header_section header_section_sim">
            {/* <div className="bg-overlay" / >*/}
            <div className="container">
              <div className="row">

              <div className="col-lg-6">
                <div className="desktop-header">
                  <h1 className="sub no-margin bold600 mb-3">
                    Connect to internet<br/>with your Smartphone
                  </h1>
                </div>
              </div>

              <div className="col-lg-6"></div>


                {/*
                  <div className="mobile-header">
                  <h2 className="SansSerif bold600 m-title-positon">
                    <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                    <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                    MightyWifi Cloud
                  </h2>
                </div>
                */}

              </div>
            </div>
            <div id="SimSection"></div>
          </section>
        );
    }
}

export default ConnectToInternet;



// WEBPACK FOOTER //
// ./src/reusable/ConnectToInternet.js